<div [class.isPrinting]="printService.isPrinting">
  <ngx-spinner bdColor="rgba(0,0,0,0)"
               size="medium"
               color="#000000"
               type="ball-spin-clockwise">
  </ngx-spinner>


  <div class="row margin-left-0px margin-right-0px">
    <div class="col-md-12 padding-right-0px padding-left-0px">
      <div class="card">

        <div class="card-body padding-all-0px">
          <div class="row margin-left-10px">
            <!--<div class="col-md-3 margin-left-10px margin-top-5px">
              <div class="card Ipbillcard-border">
                <div class="card-body padding-all-8px">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="margin-bottom-0px font-size-14">Total Advance</label>
                    </div>:
                    <div class="col-md-5">

                      <label class="margin-bottom-0px font-size-14">25000</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="margin-bottom-0px font-size-14">Total Bill</label>
                    </div>:
                    <div class="col-md-5">
                      <label class="margin-bottom-0px font-size-14">45000</label>
                    </div>
                  </div>
                  <div class="row border-top-due">
                    <div class="col-md-6">
                      <label class="margin-bottom-0px font-size-14">Due</label>
                    </div>:
                    <div class="col-md-5">
                      <label class="margin-bottom-0px font-size-14">20000</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>-->
            <div class="col-md-2 mistable-data">
              <div class="row margin-left-0px font-size-12px font-weight-bold">
                Total Advance
              </div>
              <div class="row margin-left-0px misdatafont" *ngIf="TotalAdvance">
                {{TotalAdvance | number:'1.2-2' |removeComma}}
              </div>
            </div>
            <div class="col-md-2 mistable-data">
              <div class="row margin-left-0px font-size-12px font-weight-bold">
                Total Bill
              </div>
              <div class="row margin-left-0px misdatafont" *ngIf="CurrentX_BillHeaderController">
                {{CurrentX_BillHeaderController.TotalAmount}}
              </div>
            </div>
          </div>
          <div class="row  margin-right-0px margin-top-15px margin-left-15px margin-right-10px">
            <div class="col-md-12 padding-right-0px padding-left-0px">
              <div class="card">
                <div class="card-header wh-header font-size-16px font-weight-normal border-left-clinical padding-top-6px padding-left-15px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="margin-bottom-0px">Advances</label>
                    </div>
                    <div class="col-md-9 text-align-right padding-left-0px padding-right-0px">
                      <div class="display-inline" *canUserAccess="['HL_AD_4']">
                        <button type="submit" class="btn btn-profile actions-btn-prime-profile2 nav-link-hand font-size-13px margin-right-5px" (click)="admnadvbill()">
                          <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Print
                        </button>
                      </div>
                      <div class="display-inline" *canUserAccess="['HL_AD_3']">
                        <button type="button" (click)="AddAdv()" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right">
                          <i class="fa fa-plus color-Assign margin-right-3px"></i>Add Adv
                        </button>
                      </div>
                      <!--<button type="button" (click)="Addbill()" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right"><i class="fa fa-plus color-Assign margin-right-3px"></i>Add Bill</button>-->
                    </div>
                  </div>
                </div>
                <div class="card-body padding-all-0px">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="table-component">
                        <div class="table-responsive overflow-x">


                          <table class="table table-striped"
                                 cols="auto,2*,*,*,*,*,*,*">

                            <thead class="">
                              <tr>

                                <th class="min-width-24px">
                                  #
                                </th>


                                <th class="">
                                  Date
                                </th>
                                <th class="">
                                  Receipt No
                                </th>
                                <th> Payment Mode</th>

                                <th class="">
                                  Amount
                                </th>

                                <th></th>







                              </tr>
                            </thead>

                            <tbody class="table-body">
                              <tr *ngFor="let l of CurrentBillAdvancesListController ; let RowIndex = index ">


                                <td class="td-padding-tb">

                                  {{RowIndex+1}}

                                </td>
                                <td class=" td-padding-tb">{{l.BillDate | date:'MMM-dd-yyyy'}}</td>

                                <td class="td-padding-tb padding-right-0px">{{l.ReceiptFormattedCode}}</td>
                                <td class="text-align-left td-padding-tb ">{{l.PaymentInstrument}}</td>
                                <td class="td-padding-tb  padding-right-15px">{{l.AdvanceAmount | number:'1.2-2' |removeComma}}</td>

                                <td class=" td-padding-tb">
                                  <a class="nav-link-hand padding-left-5px padding-top-5px education-navlink" title="print" (click)="SelectAdvance(l)">
                                    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                                  </a>
                                </td>




                              </tr>


                            </tbody>



                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
          <div class="row  margin-right-0px margin-top-15px margin-left-15px margin-right-10px">
            <div class="col-md-12 padding-right-0px padding-left-0px">
              <div class="card">
                <div class="card-header wh-header font-size-16px font-weight-normal border-left-clinical padding-top-6px padding-left-15px background-billinfo">
                  <div class="row">
                    <div class="col-md-3 padding-left-10px">
                      <label class="margin-bottom-0px margin-top-3px">BILL Information</label>
                    </div>
                    <div class="col-md-9 text-align-right padding-left-0px padding-right-0px">
                      <div class="display-inline" *canUserAccess="['HL_AD_5']">
                        <button type="submit" class="btn btn-profile actions-btn-prime-profile2 nav-link-hand font-size-13px margin-right-5px" (click)="admnbillsummary()">
                          <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Bill Summary
                        </button>
                      </div>
                      <div class="display-inline" *canUserAccess="['HL_AD_5']">
                        <button type="submit" class="btn btn-profile actions-btn-prime-profile2 nav-link-hand font-size-13px margin-right-5px" (click)="admnitemwisebill()">
                          <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Item-Wise Bill
                        </button>
                      </div>
                      <div class="display-inline" *canUserAccess="['HL_AD_2']">
                        <button type="button" (click)="EditBill()" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right">
                          Bill Settlement
                        </button>
                      </div>
                      <!--<button type="button" (click)="EditIp()" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right">
                        <i class="fas fa-pencil-alt nav-link-hand font-size-14 "></i>  Edit
                      </button>-->
                      <!--<button class="btn actions-btn-prime font-size-13px float-right margin-right-5px" (click)="EditIp()">Edit <i class="fas fa-pencil-alt nav-link-hand font-size-14 "></i></button>-->

                    </div>
                  </div>
                </div>
                <div class="card-body padding-all-0px">
                  <div class="row">
                    <div class="col-md-5 margin-left-10px margin-top-5px margin-bottom-5px">
                      <div class="card Ipbillcard-border">

                        <div class="card-body padding-all-8px">
                          <div class="row">
                            <div class="col-md-6">
                              <label class="margin-bottom-0px font-size-14">Bill Date</label>
                            </div>:
                            <div class="col-md-5">

                              <label class="margin-bottom-0px font-size-14" *ngIf="CurrentX_BillHeaderController">{{CurrentX_BillHeaderController.BillDate| date:'dd-MMM-yyyy'}}</label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <label class="margin-bottom-0px font-size-14">Bill No</label>
                            </div>:
                            <div class="col-md-5">
                              <label class="margin-bottom-0px font-size-14" *ngIf="CurrentX_BillHeaderController">{{CurrentX_BillHeaderController.FormattedCode}}</label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <label class="margin-bottom-0px font-size-14">Branch </label>
                            </div>:
                            <div class="col-md-5">
                              <label class="margin-bottom-0px font-size-14" *ngIf="CurrentX_BillHeaderController">{{CurrentX_BillHeaderController.BranchName}}</label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <label class="margin-bottom-0px font-size-14">Total </label>
                            </div>:
                            <div class="col-md-5">
                              <label class="margin-bottom-0px font-size-14" *ngIf="CurrentX_BillHeaderController">{{CurrentX_BillHeaderController.Net}}</label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <label class="margin-bottom-0px font-size-14">Discount </label>
                            </div>:
                            <div class="col-md-5">
                              <label class="margin-bottom-0px font-size-14" *ngIf="CurrentX_BillHeaderController">{{CurrentX_BillHeaderController.Discount}}</label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <label class="margin-bottom-0px font-size-14">Paid </label>
                            </div>:
                            <div class="col-md-5">
                              <label class="margin-bottom-0px font-size-14" *ngIf="CurrentX_BillHeaderController">{{CurrentX_BillHeaderController.Paid}}</label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <label class="margin-bottom-0px font-size-14">Due </label>
                            </div>:
                            <div class="col-md-5">
                              <label class="margin-bottom-0px font-size-14" *ngIf="CurrentX_BillHeaderController">{{CurrentX_BillHeaderController.Balance}}</label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <label class="margin-bottom-0px font-size-14">Status </label>
                            </div>:
                            <div class="col-md-5">
                              <label class="margin-bottom-0px font-size-14" *ngIf="CurrentX_BillHeaderController">{{CurrentX_BillHeaderController.RecordStatus}}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row margin-right-0px margin-top-15px margin-left-15px margin-right-10px">
            <div class="col-md-12 padding-right-0px padding-left-0px">
              <div class="card">
                <div class="card-header wh-header font-size-16px font-weight-normal border-left-clinical padding-top-6px padding-left-15px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="margin-bottom-0px">Bill Items</label>
                    </div>
                    <div class="col-md-9 text-align-right padding-left-0px padding-right-0px">


                      <!--<button type="button" (click)="AddAdv()" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right">
                        <i class="fa fa-plus color-Assign margin-right-3px"></i>Add Adv
                      </button>-->
                      <!--<button type="button" (click)="Addbill()" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right"><i class="fa fa-plus color-Assign margin-right-3px"></i>Add Bill</button>-->
                    </div>
                  </div>
                </div>
                <div class="card-body padding-all-0px">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="table-component">
                        <div class="table-responsive overflow-x">


                          <table class="table table-striped"
                                 cols="auto,2*,*,*,*,*,*,*">

                            <thead class="">

                              <tr>

                                <th class="min-width-24px padding-top-4px padding-bottom-4px th-sticky">
                                  #
                                </th>


                                <th class="padding-top-4px padding-bottom-4px th-sticky">
                                  Item Description
                                </th>
                                <th class="padding-top-4px padding-bottom-4px th-sticky">
                                  Date
                                </th>

                                <th class="padding-top-4px padding-bottom-4px th-sticky">
                                  QTY
                                </th>

                                <th class="padding-top-4px padding-bottom-4px th-sticky">
                                  Unit Price
                                </th>
                                <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                                  Item Total
                                </th>
                                <th class="padding-top-4px padding-bottom-4px th-sticky">
                                  Disc %
                                </th>
                                <th class="padding-top-4px padding-bottom-4px th-sticky text-align-center padding-left-0px">
                                  Net
                                </th>

                                <!--<th class="">

                                </th>-->
                                <!--<th class="padding-top-4px padding-bottom-4px th-sticky">

                                </th>-->






                              </tr>
                            </thead>

                            <tbody class="table-body">
                              <tr *ngFor="let l of CurrentX_BillItemsController ; let RowIndex = index ">


                                <td class="td-padding-tb">

                                  {{RowIndex+1}}

                                </td>
                                <td class=" td-padding-tb">{{l.ItemDescription}}</td>
                                <td class="td-padding-tb">{{l.ItemEntryDate| date:'dd-MMM-yyyy'}}</td>
                                <td class="text-align-center td-padding-tb">
                                  {{l.Quantity}}
                                  <!--<input type="number" class="form-control text-align-right td-width-82px" placeholder=""
                                  [(ngModel)]="l.quantity"
                                  maxlength="2" required>-->
                                  <!--<label *ngIf="!l.Edit" class="margin-bottom-0px">{{l.Quantity}}</label>-->
                                  <!--<input  type="number" class="form-control text-align-right td-width-82px" placeholder=""
                                  [(ngModel)]="l.Quantity"
                                  maxlength="2" required>-->
                                  <!--<CodeTypeValue CodeType="1to5"
                                                 id="l.Quantity" (keyChange)="Qunatitychange(l)"
                                                 [(ngModel)]="l.Quantity" SelectedValue="l.Quantity"
                                                 name="l.Quantity">
                                  </CodeTypeValue>-->


                                </td>
                                <td class="text-align-center td-padding-tb padding-right-0px">
                                  <!--{{l.UnitPrice}}-->
                                  <!--<input *ngIf="l.EditableCharge" type="text" class="form-control text-align-right td-width-82px" placeholder="" (input)="Itemchange(l)"
                                         [(ngModel)]="l.UnitPrice"
                                         maxlength="10" required>-->
                                  <label class="margin-bottom-0px">{{l.UnitPrice}}</label>
                                </td>
                                <td class="td-padding-tb text-align-center padding-right-0px"> <label class="margin-bottom-0px">{{l.Quantity * l.UnitPrice}}</label></td>
                                <td class="td-padding-tb text-align-center">
                                  <!--<input *ngIf="l.DiscountAllowed" type="number" class="form-control text-align-right td-width-82px" placeholder=""
                                  [(ngModel)]="l.discount"
                                  maxlength="2" required>-->
                                  <!--<input *ngIf="l.DiscountAllowed" type="text" class="form-control text-align-right td-width-82px " placeholder="Discount"
                                         id="l.Discount"
                                         [(ngModel)]="l.Discount" (input)="Discountchange(l)"
                                         name="l.Discount" #Endometrium="ngModel"
                                         maxlength="5" pattern="^[\0-9,._\-?]*$">-->
                                  <!--<CodeTypeValue *ngIf="l.DiscountAllowed" CodeType="5to25" class="bill"
                                                 id="l.Discount" (keyChange)="Discountchange(l)"
                                                 [(ngModel)]="l.Discount" SelectedValue="l.Discount"
                                                 name="l.Discount">
                                  </CodeTypeValue>-->

                                  <label class="margin-bottom-0px">{{l.Discount}}</label>

                                </td>
                                <td class="text-align-center td-padding-tb padding-right-0px padding-left-0px">{{(l.Quantity * l.UnitPrice)-(l.Quantity * l.UnitPrice * (l.Discount / 100)) | number:'1.2-2' |removeComma}}</td>






                              </tr>


                            </tbody>



                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>
<!--<div class="row" *ngIf="Formedit">
  <div class="col-md-8 padding-left-0px">
    <div class="card">
      <div class="card-body padding-all-0px">
        <div *ngIf="FormData" class="margin-top-10">
          <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngFor="let l of FormData;let RowIndex = index">
            <div [id]="'accordion'+RowIndex">
              <div class="card-header wh-header font-size-16px  padding-top-6px padding-bottom-6px card-header-bg border-left-clinical padding-l-8px padding-right-8px font-weight-normal2 font-size-16px" [id]="'heading'+RowIndex">
                <div class="row">
                  <div class="col-md-3">
                    <h5 class="mb-0">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                              aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                        {{l.Title
                                }}

                                </button>

                                </h5>
</div>
                  <div class="col-md-9">
                    <button type="submit" class="btn actions-btn-prime float-right">Save</button>
                    <button type="button"
                            (click)="Backtolist()" class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3 float-right margin-right-10px">
                      Cancel
                    </button>
                  </div>
                </div>


              </div>
              <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                   [attr.data-parent]="'#accordion'+RowIndex">
                <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">

                  <div class="row col-md-12 card" *ngFor="let f of l.Fields">


                    <div class="card-header wh-header font-size-14 padding-l-8px padding-t-6px padding-bottom-0px padding-right-0px" *ngIf="f.isHeader">
                      {{f.Title}}
                    </div>
                    <div class="card-body padding-bottom-0px padding-top-0px margin-left-zero">
                      <div *ngIf="f.isSubHeader">
                        <label class="font-size-14 margin-bottom-0px">{{f.Title}}</label>
                      </div>


                      <div *ngIf="f.isTextField">
                        <div class="row form-group">
                          <div class="col-md-3 padding-right-0px text-align-right">
                            <label class="font-size-12px margin-bottom-0px margin-top-10">{{f.Title}}</label>
                          </div>
                          <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="Value" required maxlength="100" minlength="1">
                          </div>
                        </div>


                      </div>
                      <div *ngIf="f.isSubChild">
                        <div class="row form-group">
                          <div class="col-md-3 text-align-right">
                            <label class="font-size-12px margin-bottom-0px margin-top-10">{{f.Title}}</label>
                          </div>:
                          <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="Value" required maxlength="100" minlength="1">
                          </div>
                        </div>
                      </div>


                      <div *ngIf="f.Remarks">
                        <label class="margin-left-10px margin-bottom-0px">{{f.Remarks}}</label>
                      </div>
                      <div *ngIf="f.HasSeparator">
                        <div class="border-bottom-light"></div>
                      </div>
                    </div>
                  </div>



                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">

  </div>
</div>-->
<!--<div class="row">
  <div class="col-md-12">
    <medicalrecordview [FormattedCode]="FormattedCode" *ngIf="viewhealthrecord"></medicalrecordview>
  </div>

</div>-->
